import { toast } from "sonner";
import { create } from "zustand";

/** Timer de foco (plugin kompil.focus-timer): ciclos de 25 min de foco e 5 min de pausa. */
const FOCUS_MS = 25 * 60_000;
const BREAK_MS = 5 * 60_000;

interface FocusTimerState {
  phase: "focus" | "break";
  running: boolean;
  /** Fim do ciclo atual (epoch ms) quando rodando; tempo restante quando pausado. */
  endsAt: number;
  remainingMs: number;
  cycles: number;
  start(): void;
  pause(): void;
  reset(): void;
  /** Avança o relógio: chamado a cada segundo pela barra de status. */
  tick(now: number): void;
}

export const useFocusTimer = create<FocusTimerState>((set, get) => ({
  phase: "focus",
  running: false,
  endsAt: 0,
  remainingMs: FOCUS_MS,
  cycles: 0,
  start: () => set((s) => ({ running: true, endsAt: Date.now() + s.remainingMs })),
  pause: () => set((s) => ({ running: false, remainingMs: Math.max(0, s.endsAt - Date.now()) })),
  reset: () => set({ phase: "focus", running: false, remainingMs: FOCUS_MS, endsAt: 0 }),
  tick: (now) => {
    const s = get();
    if (!s.running) return;
    const left = s.endsAt - now;
    if (left > 0) return set({ remainingMs: left });
    const next = s.phase === "focus" ? "break" : "focus";
    const duration = next === "focus" ? FOCUS_MS : BREAK_MS;
    toast(next === "break" ? "Ciclo de foco concluído" : "Pausa encerrada", {
      description: next === "break" ? "Hora de uma pausa de 5 minutos." : "De volta ao código.",
    });
    set({
      phase: next,
      endsAt: now + duration,
      remainingMs: duration,
      cycles: s.cycles + (s.phase === "focus" ? 1 : 0),
    });
  },
}));

export function formatClock(ms: number) {
  const total = Math.ceil(ms / 1000);
  return `${String(Math.floor(total / 60)).padStart(2, "0")}:${String(total % 60).padStart(2, "0")}`;
}
